import { t } from 'i18next';
import { HEALTH_STATUS } from 'vio-constants';
import { alphabetize, sortAlphabetically, sortByDateValue, sortByNumericalValue } from 'vio-libs';
export function sortByLastLogin(firstValue, secondValue, isDescending = false, consumerAPI = false) {
    let firstCreatedAt;
    let firstLogin;
    let secondCreatedAt;
    let secondLogin;
    ({
        created_at: firstCreatedAt,
        last_login: firstLogin
    } = firstValue);
    ({
        created_at: secondCreatedAt,
        last_login: secondLogin
    } = secondValue);
    if (consumerAPI) {
        ({
            created: firstCreatedAt,
            last_login: firstLogin
        } = firstValue);
        ({
            created: secondCreatedAt,
            last_login: secondLogin
        } = secondValue);
    }
    if (firstLogin === 'None' && secondLogin === 'None') {
        return sortByDateValue(firstCreatedAt, secondCreatedAt, false);
    }
    if (firstLogin === 'None') {
        return 1;
    }
    if (secondLogin === 'None') {
        return -1;
    }
    return sortByDateValue(firstLogin, secondLogin, !isDescending);
}
export function sortByPower(firstProp, secondProp, isDescending = false) {
    if (!firstProp || firstProp === t('NA', {
        ns: 'Common'
    })) {
        return 1;
    }
    if (!secondProp || secondProp === t('NA', {
        ns: 'Common'
    })) {
        return -1;
    }
    const firstValue = parseInt(firstProp.split(' ')[0]);
    const secondValue = parseInt(secondProp.split(' ')[0]);
    return sortByNumericalValue(firstValue, secondValue, isDescending);
}
export function sortByMemberships(firstMemberships, secondMemberships, isDescending = false) {
    if (!firstMemberships) {
        return 1;
    }
    if (!secondMemberships) {
        return -1;
    }
    const firstMembership = firstMemberships[0];
    const firstMembershipRoles = firstMembership.roles;
    const firstRolesCount = firstMembershipRoles.length;
    const secondMembership = secondMemberships[0];
    const secondMembershipRoles = secondMembership.roles;
    const secondRolesCount = secondMembershipRoles.length;
    if (firstRolesCount > secondRolesCount) {
        return isDescending ? -1 : 1;
    }
    if (firstRolesCount < secondRolesCount) {
        return isDescending ? 1 : -1;
    }
    const firstRoles = alphabetize(firstMembershipRoles.map(role => role.name)).join(', ');
    const secondRoles = alphabetize(secondMembershipRoles.map(role => role.name)).join(', ');
    return sortAlphabetically(firstRoles, secondRoles, isDescending);
}
export function sortByStatus(firstProp, secondProp, isDescending = false) {
    if (!firstProp) {
        return 1;
    }
    if (!secondProp) {
        return -1;
    }
    const firstStatus = firstProp.toUpperCase();
    const secondStatus = secondProp.toUpperCase();
    const firstValue = HEALTH_STATUS[firstStatus];
    const secondValue = HEALTH_STATUS[secondStatus];
    return sortByNumericalValue(firstValue, secondValue, isDescending);
}
